import {
  ALL_SPECIES,
  ANIMAL_GENDERS,
  ANIMAL_STATUS_ENUM,
  matchesAnimalAge,
  type Animal,
  type AnimalLifeSpan,
} from "@/features/farm"
import { getMonthsFromDateOfBirth } from "@/utils/helpers/time-utils.ts"

export interface AnimalFilterSelection {
  searchQuery: string
  gender: string
  species: string
  age: AnimalLifeSpan
  status: string
  outOfExploitation: boolean
}

export enum ANIMAL_FILTER_ENUM {
  SEARCH_QUERY = "",
  STATUS = "status",
  GENDER = "gender",
  SPECIES = "species",
  AGE = "age",
  OUT_OF_EXPLOITATION = "outOfExploitation",
}

export const filterAnimals = (
  animals: Animal[],
  selections: AnimalFilterSelection,
) => {
  return animals.filter((animal) => {
    const animalAgeInMonths = getMonthsFromDateOfBirth(animal.birth_date)

    const matchesSearch = Object.entries(animal).some(
      ([key, value]) =>
        key !== "id" &&
        typeof value === "string" &&
        value.toLowerCase().includes(selections.searchQuery.toLowerCase()),
    )

    const matchesGender =
      selections.gender === ANIMAL_GENDERS.ALL_GENDERS.label ||
      animal.gender === selections.gender

    const matchesAnimalCategory =
      selections.species === ALL_SPECIES.label ||
      animal.species === selections.species

    const matchesStatus =
      selections.status === ANIMAL_STATUS_ENUM.ALL_STATUSES ||
      animal.statuses?.includes(selections.status)

    const matchesOutOfExploitation =
      selections.outOfExploitation === !!animal.exit_date

    const matchesAge = matchesAnimalAge(animalAgeInMonths, selections.age)

    return (
      matchesSearch &&
      matchesGender &&
      matchesAnimalCategory &&
      matchesStatus &&
      matchesOutOfExploitation &&
      matchesAge
    )
  })
}
